<template>
  <div class="leaderboard-container">
    <el-table :data="leaderboardTeam" style="width: 100%" :empty-text="$t('common.no_values')" @sort-change="sortChange" :default-sort="{ prop: sort_by, order: order_by }" v-loading="isActive && loadingTeamLeaderboard">
      <el-table-column prop="id" :label="$t($i18nLabelsHelper(currentOrganizationType, 'charts.learner_col_label'))">
        <template slot-scope="scope">
          <div class="member">
            <p class="index">{{ scope.$index + 1 }}</p>
            <a @click="goToDetailLink(scope.row)">
              <p>{{ scope.row.name }}</p>
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isGeneralAdmin && hasChildOrg" prop="org_name" :label="$t('charts.branch_col_label')" :filters="branchOptions" :filter-method="filterBranch" filter-placement="bottom-end" width="256">
        <template slot-scope="scope">
          <div class="branch">
            <a @click="goToBranch(scope.row)">
              <p>{{ scope.row.org_name }}</p>
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="eps" sortable='custom' :label="$t('charts.score_col_label')" :sort-orders="['descending', 'ascending']" width="256">
        <template slot="header">
          <el-tooltip :content="$t($i18nLabelsHelper(currentOrganizationType, 'charts.tooltips.group_eps'))">
            <span>{{ $t('charts.score_col_label') }}</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div class="elsa-score">
            <p>{{ Math.round(scope.row['eps']) }}%</p>
            <el-progress class="eps" :percentage="parseFloat(scope.row['eps'])" :show-text="false" :width="95"> </el-progress>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable='custom' prop="durations" align="center" :label="$t('charts.duration_col_label')" :sort-orders="['descending', 'ascending']" width="256">
        <template slot="header">
          <el-tooltip :content="$t($i18nLabelsHelper(currentOrganizationType, 'charts.tooltips.group_durations'))">
            <span>{{ $t('charts.duration_col_label') }}</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          {{ intervalToHours(scope.row, scope.column, scope.row['durations'], scope.$index) }}
        </template>
      </el-table-column>
      <el-table-column prop="lessons_total" sortable='custom' :label="$t('charts.lessons_total_col_label')" :sort-orders="['descending', 'ascending']" align="center" width="256">
        <template slot="header">
          <el-tooltip :content="$t($i18nLabelsHelper(currentOrganizationType, 'charts.tooltips.group_lessons_total'))">
            <span>{{ $t('charts.lessons_total_col_label') }}</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          {{ scope.row['lessons_total'] }}
        </template>
      </el-table-column>
    </el-table>
    <div v-if="leaderboardTeam && leaderboardTeam.length" class="table-footer more">
      <el-button type="text" @click.native="handleLoadMore" class="btn-more" icon="el-icon-caret-bottom">{{ $t('common.view_more') }}</el-button>
      <el-button type="text" @click.native="handleHide" class="btn-less" :disabled="currentpage <= 0" icon="el-icon-caret-top">{{ $t('common.view_less') }}</el-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { warningMessage } from '../../../utils/messages'
import { always } from 'ramda'
import { is, toString, compose, invoker } from 'ramda'
import showNoReportDataWarning from '@/components/common/mixins/noReportData'
import { isSessionExpireError } from '@/utils/sessionExpireErr'
const padStart = compose(invoker(2, 'padStart')(2, '0'), toString)

export default {
  mixins: [showNoReportDataWarning],
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType',
      hasChildOrg: 'organization/hasChildOrg',
      isGeneralAdmin: 'organization/isGeneralAdmin'
    }),
    numberElementsPerPage: always(5),
    ...mapState('organization', ['leaderboardTeam', 'loadingTeamLeaderboard', 'currentOrganizationId']),
    sort_by_api() {
      if (this.sort_by === 'eps') {
        return 'score'
      } else if (this.sort_by === 'durations') {
        return 'duration'
      }
      return 'lesson'
    },
    order_by_api() {
      if (this.order_by == 'descending') {
        return 'desc'
      } else if (this.order_by == 'ascending') {
        return 'asc'
      }
      return 'desc'
    },
    startDateAndendDateAndsortBy() {
      let msg = `${this.startDate}|${this.endDate}|${this.sort_by_api}|${this.order_by_api}`
      return msg
    },
    currentpage() {
      return this.leaderboardTeam ? Math.round(this.leaderboardTeam.length / 5) + (this.leaderboardTeam.length % 5 === 0 ? -1 : 0) : 0
    }
  },
  data() {
    return {
      sort_by: 'eps',
      order_by: 'descending',
      branchOptions: [],
      num_fetch_data: 0,
    }
  },
  props: ['new', 'startDate', 'endDate', 'isActive'],
  methods: {
    goToDetailLink(team) {
      const org_id = team.org_id ? team.org_id : this.currentOrganizationId
      window.location =  `/organization/${org_id}/classes/${team.id}`
    },
    goToBranch(team) {
      window.location = `/organization/${team.org_id}/dashboard`
    },
    name(userObject) {
      if (is(String, userObject)) {
        return userObject
      }

      var ret = userObject.email

      if (userObject.first_name || userObject.last_name) {
        ret = userObject ? `${userObject.first_name} ${userObject.last_name}` : ''
      }
      return ret
    },
    intervalToHours(row, column, cellValue, index) {
      if (!is(Number, cellValue)) {
        return '00:00:00'
      }
      const hours = Math.floor(cellValue / (60 * 60))
      const minutes = Math.floor((cellValue - hours * 3600) / 60)
      const seconds = cellValue - hours * 3600 - minutes * 60

      return `${padStart(hours)}:${padStart(minutes)}:${padStart(seconds)}`
    },
    async sortChange({ prop, order }) {
      this.sort_by = prop
      this.order_by = order
    },
    getTeamLeaderboardData(options) {
      return this.getTeamLeaderboard(options).catch((err) => {
        if(!isSessionExpireError(err))
          this.showNoReportDataWarning()
      })
    },
    ...mapActions({
      getTeamLeaderboard: 'organization/getTeamLeaderboard',
      hideTeamLeaderboard: 'organization/hideTeamLeaderboard'
    }),
    async handleLoadMore() {
      const page = this.leaderboardTeam ? Math.round(this.leaderboardTeam.length / 5) + (this.leaderboardTeam.length % 5 === 0 ? 0 : 1) : 0
      await this.getTeamLeaderboardData({
        from: this.startDate,
        to: this.endDate,
        scope: this.scope,
        team_cursor: page,
        team_sort_by: this.sort_by_api,
        team_order_by: this.order_by_api,
        replace: false
      })
    },
    handleHide() {
      this.hideTeamLeaderboard()
    },
    filterBranch(value, row) {
      return row.org_id === value;
    },
  },
  mounted() {
    window.onscroll = async () => {
      let bottomOfWindow = document.documentElement.offsetHeight - (document.documentElement.scrollTop + window.innerHeight) < 150;
      if (bottomOfWindow && !this.leaderboardTeam && this.num_fetch_data < 1) {
        this.num_fetch_data++;
        try {
          await this.getTeamLeaderboardData({
            from: this.startDate,
            to: this.endDate,
            scope: this.scope,
            team_cursor: 0,
            team_sort_by: this.sort_by_api,
            team_order_by: this.order_by_api,
            replace: true
          })
        } catch (error) {
          return warningMessage(this.$t('common.generic_error_message'))
        }
      }
    }
  },
  destroyed() {
    window.onscroll = null;
  },
  watch: {
    startDateAndendDateAndsortBy: {
      async handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          await this.getTeamLeaderboardData({
            from: this.startDate,
            to: this.endDate,
            scope: this.scope,
            team_cursor: 0,
            team_sort_by: this.sort_by_api,
            team_order_by: this.order_by_api,
            replace: true
          })
        }
      }
    },
    leaderboardTeam(val) {
        val.forEach((option) => {
          const _branchOption = {
            text: option.org_name,
            value: option.org_id
          }
          if(!this.branchOptions.find(item => item.value === _branchOption.value) && _branchOption.value) {
            this.branchOptions.push(_branchOption)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.team-tab-body {
  padding: 40px;
  text-align: center;
}

// button {
//   background: #007eff;
//   border-radius: 8px;
//   border: none;
//   height: 48px;
//   color: white;
//   padding: 16px;
//   font-size: 18px;
//   min-width: 215px;
//   cursor: pointer;
//   // font-weight: bold;
//   margin: 0 10px;
//   &:hover {
//     background: #0362c4;
//   }
// }
.no-item-title {
  font-weight: 600;
  font-size: 32px;
  text-align: center;
}
.no-item-desc {
  font-size: 18px;
}

.elsa-score {
  display: flex;
  align-items: center;

  .eps {
    width: 95px;
    margin-left: 12px;
  }
}

.leaderboard-container {
  display: flex;
  flex-direction: column;

  .table-footer.more {
    background-color: rgba(47, 128, 237, 0.1);
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    display: flex;
    justify-content: space-around;
    margin: 0px;

    .btn-more:not([disabled]),
    .btn-less:not([disabled]) {
      // background-color: rgba(47, 128, 237, 0.1);
      // margin: 0px;
      color: #2f80ed;
      // border-top-left-radius: 0px;
      // border-top-right-radius: 0px;
      font-size: 14px;

      &:hover,
      &.active,
      &.focus {
        color: #0362c4;
      }
    }
  }

  &::v-deep .el-table__body {
    p,
    span {
      font-size: 16px;
      color: #121131;
      font-weight: 500;
    }
  }

  &::v-deep .el-table__header-wrapper .cell {
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
  }

  .member {
    display: flex;
    flex-direction: row;
    .index {
      margin-right: 15px;
    }
  }
  .branch {
    p {
      color: #478DFF;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
    }
  }
}
::v-deep .el-table__column-filter-trigger i {
  font-size: 20px;
  color:$black;
}
::v-deep .el-table__column-filter-trigger .el-icon-arrow-down:before {
  content: "\e790";
}
</style>
